module.exports = __webpack_public_path__ + "static/media/2.18_preview.7c150322.png";